export default "__VITE_ASSET__Ck0P1OG1__"